import { forwardRef, HTMLAttributes } from 'react';
import { Button, Flex } from 'antd';
import { Tooltip } from '../../components/Tooltip';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import styled from 'styled-components';
import * as Icon from 'react-feather';
import {
  colorTableOperationIcon,
  lineHeightPx,
} from '@atlas-frontend/design-tokens';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './DragIcon.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('row-drag-icon');
addTranslations(translations);

export interface DragIconProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'color'> {
  id: string;
  size?: SizeType;
  isDisabled?: string | boolean;
}

export const DragIcon = forwardRef<HTMLDivElement, DragIconProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const { id, size, isDisabled, ...rest } = props;

    const button = (
      <Button
        id={id}
        type="text"
        shape="circle"
        icon={
          <>
            <Icon.MoreVertical size={20} color={colorTableOperationIcon} />
            <Icon.MoreVertical size={20} color={colorTableOperationIcon} />
          </>
        }
        disabled={Boolean(isDisabled)}
        {...rest}
      />
    );

    return (
      <IconWrapper ref={ref} align="center" justify="center">
        {typeof isDisabled === 'string' ? (
          <Tooltip title={t(`disabled.${isDisabled}`)} placement="right">
            {button}
          </Tooltip>
        ) : (
          button
        )}
      </IconWrapper>
    );
  }
);

const IconWrapper = styled(Flex)`
  // 2px border + 32px button height
  margin-block: ${(lineHeightPx + 2 - 32) / 2}px;

  button {
    touch-action: none;
    cursor: move;

    &[aria-disabled='true'] {
      cursor: not-allowed;
      opacity: 0.4;
    }

    svg + svg {
      margin-left: -14px;
    }
  }
`;
